import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import Container from './container'

export default function TecnologiasUtilizadas() {
  const { openModal } = useModal()
  return (
    <section className="bg-[#040116] text-white">
      <Container className="pt-8 pb-[78px] md:pt-28 md:pb-40 flex flex-col items-center gap-12 md:gap-16">
        <h2 className="text-2xl md:text-5xl font-inter-regular text-center">
          Tecnologias utilizadas
        </h2>

        <img src="../assets/logotipos.png" alt="" className="hidden md:block" />

        <div>
          <img
            src="../assets/logotipos-mobile-1.png"
            alt=""
            className="md:hidden"
          />
          <img
            src="../assets/logotipos-mobile-2.png"
            alt=""
            className="md:hidden"
          />
        </div>

        <button
          type="button"
          onClick={() => openModal(<FormularioRD />)}
          className="bg-white py-2 px-6 rounded-full font-inter-light text-xl hover:scale-105 transition-transform duration-300 cursor-pointer"
        >
          <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">
            Conheça nossas soluções
          </span>
        </button>
      </Container>
    </section>
  )
}
